import { IconProps } from ".";
import { coalColor } from "../../../styles/theme";

export const ChatPersonIcon = ({
  className,
  color = coalColor,
  size = 14,
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    className={className}
  >
    <path
      d="M2.3 1.5h9.4a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-1.5 1.5H6.6l-2.4 2.4a.3.3 0 0 1-.5-.2v-2.2H2.3A1.5 1.5 0 0 1 .8 9V3a1.5 1.5 0 0 1 1.5-1.5Z"
      fill="none"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="7"
      cy="4.4"
      r="1.2"
      fill="none"
      stroke={color}
      strokeWidth="1.2"
    />
    <path
      d="M3.8 8.6c.6-1.4 1.9-2 3.2-2s2.6.6 3.2 2"
      fill="none"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
